export const UPDATE_PARTNER_OF_PARTNER_MUTATION = gql`
    mutation updatePartnerOfPartner($id: Int!, $input: UpdatePartnerOfPartnerInput!) {
        updatePartnerOfPartner(id: $id, input: $input) {
            id
            bank {
                bic
                iban
            }
            business {
                legalName
            }
            notes {
                body
                id
                createdAt
                createdBy {
                    username
                }
            }
        }
    }
`;
